import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
// PrimeNG
import { ImageModule } from 'primeng/image';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';

@Component({
  selector: 'app-auth-layout',
  imports: [ImageModule, ButtonModule, TranslocoModule, LanguageConfigComponent],
  template: `
    <div class="flex h-screen flex-column">
      <div class="flex align-items-center justify-content-between gap-2 p-2">
        <p-button [label]="'check_email.back_to_home' | transloco" class="flex" (click)="handleRedirect()" />
        <app-language-config></app-language-config>
      </div>
      <div class="flex h-full w-full justify-content-center align-items-center bg-landing">
        <div
          class="flex flex-column gap-4 justify-content-center align-items-center border-round-2xl bg-white"
          style="width: 420px; height:310px"
        >
          <p-image src="assets/images/img-check-email.png" alt="check-email" width="62px" />
          <p class="text-lg text-color font-semibold text-center">{{ 'check_email.header' | transloco }}</p>
          <p class="text-center text-xs text-bluegray-500 font-normal text-center px-4">
            {{ 'check_email.sub_header1' | transloco }}
            <br />
            {{ 'check_email.sub_header2' | transloco }}
          </p>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class CheckEmailComponent {
  router = inject(Router);

  async handleRedirect() {
    await this.router.navigate(['/']);
  }
}
